// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODFIED DATA : 07-12-2025
import CreditBureauReportActionTypes from './credit-bureau-report.types';

/****************  GET CREDIT BUREAU REPORT LIST START *********************** */
export const getCreditBureauReportDetailsStart = (getData: any) => ({
	type: CreditBureauReportActionTypes.GET_CREDIT_BUREAU_REPORT_LIST_START,
	payload: getData,
});

export const getCreditBureauReportDetailsSuccess = (successData: any) => ({
	type: CreditBureauReportActionTypes.GET_CREDIT_BUREAU_REPORT_LIST_SUCCESS,
	payload: successData,
});

export const getCreditBureauReportDetailsFailure = (failureData: any) => ({
	type: CreditBureauReportActionTypes.GET_CREDIT_BUREAU_REPORT_LIST_FAILURE,
	payload: failureData,
});

export const getCreditBureauReportDetailsResponseResetStart = () => ({
	type: CreditBureauReportActionTypes.GET_CREDIT_BUREAU_REPORT_LIST_RESPONSE_RESET,
});

export const getCreditBureauReportDetailsResponseChanged = () => ({
	type: CreditBureauReportActionTypes.GET_CREDIT_BUREAU_REPORT_LIST_RESPONSE_CHANGED,
});
/****************  GET CREDIT BUREAU REPORT LIST END *********************** */
